import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  Container,
  Row } from 'reactstrap';

class PersonifyApproved extends Component {
  render() {
    return (
      <div className="page-personify narrow">
        <Container>
          <Row>
            <Col className="text-center mb-2 mt-2 mt-md-5">
              <img src="/images/personify-approve.svg" alt="Approved" className="mb-3" />
              <h2 className="mb-4">Congratulations!<br /> Your loan is pre-approved with</h2>
              <img src="/images/personify-logo-dark.png" alt="Personify Financial" width="290" className="mb-4" />
              <p className="mb-2">Please have your merchant proceed to the next step</p>
              <Button tag={Link} to="/personify/select-offer" color="personify" size="lg" className="mb-2 mt-1">Merchant continue to next step</Button>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default PersonifyApproved;
